import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _Wrapper from "Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/wrapper.js?styleId=Wrapper";


const topSpace = 66
const bottomSpace = 30
const panelHeight = 700
const heightBreakpoint = topSpace + bottomSpace + panelHeight

const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper,
  attrs: props => ({
    ...props,
    'media-tablet-up': useDeviceType('isTabletUp'),
    'media-desktop-up': useDeviceType('isDesktopUp')
  })
})

export default Wrapper
